import { useCallback, useEffect, useState } from 'react';
import { athleteSettingsApi } from '../services/athleteSettingsApi';
import { subscribeAthleteZones } from '../services/athleteZonesCache';

/** Preload on entry, share API data app-wide, and refresh after zone/settings edits. */
export function useAthleteZones(userId: number | null | undefined) {
  const [state, setState] = useState<{ userId: number; zones: Record<string, unknown> | null; loading: boolean } | null>(null);
  const [retry, setRetry] = useState(0);
  const reload = useCallback(() => setRetry(value => value + 1), []);
  useEffect(() => {
    if (!userId) return;
    let active = true;
    let generation = 0;
    const load = () => {
      const requestGeneration = ++generation;
      setState(previous => ({ userId, zones: previous?.userId === userId ? previous.zones : null, loading: true }));
      void athleteSettingsApi.getAthleteZones(userId).then(response => {
        if (active && generation === requestGeneration) setState({ userId, zones: response.data.data.zones ?? null, loading: false });
      }, () => {
        if (active && generation === requestGeneration) setState({ userId, zones: null, loading: false });
      });
    };
    const unsubscribe = subscribeAthleteZones(userId, load);
    load();
    return () => { active = false; unsubscribe(); };
  }, [userId, retry]);
  const current = state?.userId === userId ? state : null;
  return { zoneSettings: current?.zones ?? null, loading: userId ? current?.loading ?? true : false, reload };
}
